import React from 'react'
import TextareaAutosize from 'react-autosize-textarea'
import PropTypes from 'prop-types'
import styles from './Input.module.scss'

const Input = ({ id, label, value, onChange }) => (
  <div className={styles.container}>
    <TextareaAutosize
      id={id}
      rows={1}
      value={value}
      className={styles.input}
      onChange={event => {
        onChange && onChange(event.target.value)
      }}
    />
    <label htmlFor={id} className={styles.label}>
      {label}
    </label>
  </div>
)

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

Input.defaultProps = {
  label: '',
  value: '',
  onChange: null,
}

export default Input
